"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = exports.secureDocument = void 0;

var _sanitize = _interopRequireDefault(require("sanitize"));

var secureDocument = document.implementation.createHTMLDocument('');
exports.secureDocument = secureDocument;
var config = {
  HTML: {
    elements: ['a', 'b', 'blockquote', 'br', 'caption', 'cite', 'code', 'col', 'colgroup', 'dd', 'dl', 'dt', 'em', 'figure', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'i', 'img', 'li', 'ol', 'p', 'pre', 'q', 'small', 'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul', 'font', 'div', 'span'],
    dom: secureDocument,
    attributes: {
      __ALL__: ['style', 'align', 'valign'],
      a: ['href', 'title'],
      blockquote: ['cite'],
      col: ['span', 'width'],
      colgroup: ['span', 'width'],
      figure: ['style'],
      img: ['src', 'width', 'height', 'title', 'alt', 'data-file-id', 'data-full-size-src', 'data-original-width', 'data-original-height'],
      ol: ['start', 'type'],
      q: ['cite'],
      table: ['summary', 'width', 'bgcolor'],
      td: ['abbr', 'axis', 'colspan', 'rowspan', 'width'],
      th: ['abbr', 'axis', 'colspan', 'rowspan', 'scope', 'width'],
      ul: ['type'],
      font: ['size', 'face'],
      span: ['data-at-mention', 'data-owner-id', 'contenteditable', 'data-email-reply']
    },
    add_attributes: {
      a: {
        rel: 'nofollow noopener noreferrer',
        target: '_blank'
      }
    },
    protocols: {
      a: {
        href: ['ftp', 'http', 'https', 'mailto', _sanitize.default.RELATIVE]
      },
      blockquote: {
        cite: ['http', 'https', _sanitize.default.RELATIVE]
      },
      img: {
        src: ['http', 'https', _sanitize.default.RELATIVE]
      },
      q: {
        cite: ['http', 'https', _sanitize.default.RELATIVE]
      }
    },
    remove_contents: ['style', 'script']
  },
  TEXTONLY: {
    dom: secureDocument,
    elements: [],
    remove_contents: ['style', 'script']
  }
};
exports.config = config;